import PropTypes from "prop-types"
import styled from "styled-components"

const ImageWrapper = styled.div`
  display: flex;
  position: relative;
  background-image: ${({ blob }) => (blob ? `url(${blob})` : "")};
  background-repeat: no-repeat;
  background-size: 100% 100%;
  .gatsby-image-wrapper {
    z-index: 2;
  }

  ${({ theme }) => theme.se`
    width: 100%;
    flex-direction: column;
    order: 1;
    margin-bottom: 30px;
      &.activity-graphics {
    &:first-child {
      margin: 0;
      margin-top: 0px;
      width: 97%;
    }
    &:nth-child(2) {
      margin: 0;      
      width: 97%;
    }
  }
  `}
  ${({ theme }) => theme.tablet`
    width: 60%;
    &.manage-media-image{
      width: 100%;
    }
        &.activity-graphics {
        justify-content: flex-start;
    &:first-child {
      margin: 0;
      margin-top: 0px;      
      width: 60%;
    }
    &:nth-child(2) {
      margin: 0;
      width: 60%;
    }
    
  }
  `}
    ${({ theme }) => theme.desktop`
      // width:  ${({ short }) => short && "35%"};
      width:  ${({ half, width }) => width || (half ? "48%" : "35%")};
      order: ${({ imageLeft }) => (imageLeft ? 1 : 2)};
      margin: auto;
       &.manage-media-image{
      width: 52%;
    }
        &.activity-graphics {
    &:first-child {
      margin: 0;
      margin-top: 29px;
      width: 48.5%;
    }
    &:nth-child(2) {
      margin: 0;
      width: 48.5%;
      margin-top: 13px;
    }
  }
  `}
    ${({ theme }) => theme.largeDesktop`
      &.activity-graphics {
    &:first-child {
      margin: 0;
      margin-top: 29px;
    }
    &:nth-child(2) {
      margin: 0;
      width: 48.8%;
    }
  }
  `};
`

ImageWrapper.propTypes = {
  imageLeft: PropTypes.bool,
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]).isRequired,
}

ImageWrapper.defaultProps = {
  imageLeft: false,
}

export default ImageWrapper
